import { Badge } from '@/components/ui/badge';

const categoryStyles: Record<string, string> = {
  therapeutic_developer: 'bg-blue-100 text-blue-800 border-blue-200',
  service_provider: 'bg-green-100 text-green-800 border-green-200',
  academic_institution: 'bg-purple-100 text-purple-800 border-purple-200',
  financial_partner: 'bg-amber-100 text-amber-800 border-amber-200',
  not_applicable: 'bg-gray-100 text-gray-600 border-gray-200',
  other: 'bg-gray-100 text-gray-600 border-gray-200',
};

const categoryLabels: Record<string, string> = {
  therapeutic_developer: 'Therapeutic Developer',
  service_provider: 'Service Provider',
  academic_institution: 'Academic Institution',
  financial_partner: 'Financial Partner',
  not_applicable: 'N/A',
  other: 'Other',
};

interface CategoryBadgeProps {
  category: string | null;
}

export function CategoryBadge({ category }: CategoryBadgeProps) {
  if (!category) return <span className="text-sm text-muted-foreground">—</span>;
  return (
    <Badge variant="outline" className={`text-xs ${categoryStyles[category] || categoryStyles.other}`}>
      {categoryLabels[category] || category.replace(/_/g, ' ')}
    </Badge>
  );
}
